import { isFeatureNew } from '../service/FeatureAnnouncementService';

const useFeatureAnnouncement = (feature) => {
    return { isNew: isFeatureNew(feature) };
};

export default useFeatureAnnouncement;
